export const ORG_TABLE_HEADERS = {
  name: 'Name (# of Patients)',
  id: 'ID',
  tags: 'Tags',
  view: 'Patient List',
}

export const ORG_TABLE_LOADING_ERROR =
  'Unable to load organizations. Please try again later or contact support.'

export const ORG_TABLE_NO_RESULTS = 'No results'
